import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute, } from '@common/composables'
    import { useUserAccessRequestsPage } from '@Organizations/Users/pages-core'
    import "@common/AdminNavigationV2.vue";
    import "@Organizations/Users/Components/UsersTable.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'UserAccessRequestsPage',
  setup(__props) {

    const id = parseInt(useRoute().params.id)

    const { useUserAccessRequestsQuery } = useUserAccessRequestsPage()
    const { modelUserAccessRequestsQueryV1, runUserAccessRequestsQueryV1 } = useUserAccessRequestsQuery(id, true, false)
    const requested = computed(() => modelUserAccessRequestsQueryV1.value?.Requested || [])

    onMounted(() => {
        document.title = 'User access requests'
        runUserAccessRequestsQueryV1()
    })

return { __sfc: true,id, useUserAccessRequestsQuery, modelUserAccessRequestsQueryV1, runUserAccessRequestsQueryV1, requested }
}

})